import React, { Component } from 'react';
import CommentsComponent from 'components/user/CommentsComponent.js';
import ethereum from 'decentralized/ethereum.js';

class NotesComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };

        this.getUserId();
    }

    async getUserId() {
        this.setState({
            userId: await ethereum.getUser()
        });
    }

    render() {
        if (this.state.userId === undefined) {
            return (<div></div>);
        }

        let sequenceId  = this.props.sequencerEngine.getSequenceId() 
        let sequence = {
            id: sequenceId,
        };

        return (
            <div>
              <CommentsComponent
                userId={this.state.userId}
                sequence={sequence}/>
            </div>
        );
    }
}

export default NotesComponent;
